import { CLEAR_SYSTEM_CACHE } from "../../session/type";
import {
  GET_REGISTERED_CATEGORIES_SUCCEEDED,
  GET_REGISTERED_CATEGORIES_FAILED,
  DELETE_CATEGORY_ITEM_FROM_VIEW,
  UPDATE_VIEW_CATEGORY_NAME,
  UPDATE_VIEW_CATEGORY_ORDER,
  DELETE_CATEGORY_ITEM_SUCCEEDED,
  DELETE_CATEGORY_ITEM_FAILED,
} from "./type";

interface Category {
  id: number;
  name: string;
  order: number;
  articles_count: number;
}

const initialState: Category[] = [];

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_REGISTERED_CATEGORIES_SUCCEEDED:
      return [
        // ...state,
        ...action.categories,
      ];

    case GET_REGISTERED_CATEGORIES_FAILED:
      console.log("message: ", action.message);
      return [...state];

    case UPDATE_VIEW_CATEGORY_NAME:
      const updatedNameItemIndex = state.findIndex(
        (updated_item: any) =>
          updated_item.id === Number(action.updated_target_id)
      );
      const updatedNameArray = [...state];
      updatedNameArray[updatedNameItemIndex].name = action.updated_name;
      return [...updatedNameArray];

    case UPDATE_VIEW_CATEGORY_ORDER:
      const updatedOrderItemIndex = state.findIndex(
        (updated_item: any) =>
          updated_item.id === Number(action.updated_target_id)
      );
      const updatedOrderArray = [...state];
      updatedOrderArray[updatedOrderItemIndex].order = action.updated_order;
      return [...updatedOrderArray];

    // View上で該当アイテムを削除
    case DELETE_CATEGORY_ITEM_FROM_VIEW:
      const deleted_array = state.filter((results: any, index: number) => {
        return state[index] !== state[action.deleteOrder];
      });
      return deleted_array;

    case DELETE_CATEGORY_ITEM_SUCCEEDED:
      return state;

    case DELETE_CATEGORY_ITEM_FAILED:
      return state;

    case CLEAR_SYSTEM_CACHE:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
